import * as errorTypes from '../types/Error';
import * as errorPlaceValues from '../const/ErrorPlace';

export function throwNewError(errorTitle, errorMessage){
    return {
        type:errorTypes.THROW_ERROR,
        error: {
            title: errorTitle,
            message:errorMessage
        }
    };
}

export function clearError(){
    return {
        type:errorTypes.CLEAR_ERROR
    };
}


export function throwErrorByPlace(errorPlace, error){
    return dispatch=>{
        switch (errorPlace) {
            case errorPlaceValues.COMPANY_ERROR:
                return dispatch(throwError(errorTypes.THROW_COMPANY_ERROR, error));
            case errorPlaceValues.COMPLAINT_ERROR:
                return dispatch(throwError(errorTypes.THROW_COMPLAINT_ERROR, error));
            case errorPlaceValues.COMPLAINT_POSITION_ERROR:
                return dispatch(throwError(errorTypes.THROW_COMPLAINT_POSITION_ERROR, error));
            case errorPlaceValues.CUSTOMER_ERROR:
                return dispatch(throwError(errorTypes.THROW_CUSTOMER_ERROR, error));
            default:
                break;
        }
    };
}


function throwError(type,error) {
    return {
        type: type,
        errorTitle: error.errorTitle,
        errorMessage: error.errorMessage
    };
}



// WEBPACK FOOTER //
// ./src/actions/Error.js